export default function onlyAlphabetChars(str: string) {
  return /^[a-zA-Z]*$/.test(str);
}
